import { StatisticsParameters } from 'features/systemStatistics/services/getSystemStatistics';

export const formDataInitialState: StatisticsParameters = {
  from: '',
  to: '',
};
